import React from 'react';
import { ArrowItem } from '@beisen/chaos-ui';
import * as uiUtil from '../../util/ui';
import PanelAutoComplete from './PanelAutoComplete';
import transLoader from '@beisen/i18n-translation-loader';
const defaultTranslation = {
    searchFailed: '搜索失败',
    search: '搜索',
    clear: '清空',
    cancel: '取消',
    selectHolder: '点击选择',
    required: '必填'
};
class AutoComplete extends React.Component {
  	constructor(props) {
        super(props);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleClearValue = this.handleClearValue.bind(this);
        this.afterClose = this.afterClose.bind(this);
		this.state = {
  			showPopUp: false
            ,isCancle: true
            ,visible: false
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            searchFailed: 'tip.searchFailed',
            search: 'common.search',
            clear: 'common.clear',
            cancel: 'common.cancel',
            selectHolder: 'fieldPlaceHolder.selectHolder',
            required: 'common.required'
        }), props.translation);
  	}

    componentWillMount() {
        if(this.props.pop_type == 'searchItem') {
            this.setState({ showPopUp: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.pop_type == 'searchItem' && nextProps.visible) {
            this.setState({ showPopUp: true });
        }
    }

    handleConfirm(event,data) {
        if(this.props.pop_type == 'searchItem') {
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.data = data;
            this.setState({ isCancle: false });
        }else {
            this.setState({ visible: false, isCancle: true },() => {
                this.props.onChange && this.props.onChange({ text: data[1],value: data[0] });
            });
        }
    }

    handleClearValue() {
        if(this.props.pop_type == 'searchItem') {
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.data = ['', ''];
            this.setState({ isCancle: false });
        }else {
            this.setState({ visible: false, isCancle: true });
            this.props.onChange && this.props.onChange({ text: '',value: '' });
        }
    }

    afterClose() {
        if(!this.state.isCancle) {
            this.props.onChange && this.props.onChange({ text: this.data[1],value: this.data[0] });
            this.props.synBizData && this.props.synBizData();
        }
        this.setState({ showPopUp: false });
    }

  	handleMouseDown(e) {
        this.setState({ showPopUp: true, visible: true },() => {
            this.props.onFocus && this.props.onFocus();
        });
  	}

    handleBack() {
        if(this.props.pop_type == 'searchItem') {
            this.props.handleCancel && this.props.handleCancel();
        }
        this.setState({ visible: false, isCancle: true });
    }

    renderPanel() {
        const visible = this.props.pop_type == 'searchItem' ? this.props.visible : this.state.visible;
  	    return (
            <PanelAutoComplete  onCancel={this.handleBack}
                                onSubmit={this.handleConfirm}
                                title={uiUtil.strEllipsis(this.props.cmp_label)}
                                onClearValue={this.handleClearValue}
                                datasourcename={this.props.cmp_data.datasourcename}
                                metaObjName={this.props.form_context.metaObjName}
                                formState={this.props.cmp_data.cmp_state}
                                pop_type={this.props.pop_type}
                                afterClose={this.afterClose}
                                visible={visible}
                                showTip={this.props.actions.showTip}
                                cmp_data={this.props.cmp_data}
                                translation={this.translation}
            />
  		);
	}

    renderNormalAuto() {
        const { desc } = this.props;
        const errMsg = this.props.errorMessage && this.props.errorMessage.message;
        return (
            <div className='sss'>
                <ArrowItem
                    type="text"
                    label={this.props.label}
                    value={this.props.text}
                    isReadOnly={this.props.isReadOnly}
                    onFocus={this.handleFocus}
                    onClickForm={this.handleMouseDown}
                    required={this.props.required}
                    formType={this.props.formType}
                    desc={desc}
                    placeholder={this.props.formType === 'searchForm' ?  this.props.cmp_data.promptmessage : undefined}
                    errorMsg={errMsg}
                    translation={this.translation}
                    styleTitle={this.props.styleTitle}
                />
                {this.state.showPopUp ? this.renderPanel() : null}
            </div>
        );
    }

    renderSearchItemAuto() {
        return this.state.showPopUp ? this.renderPanel() : null;
    }

    render() {
        return this.props.pop_type == 'searchItem' ? this.renderSearchItemAuto() :
               this.renderNormalAuto();
    }
}

AutoComplete.defaultProps = {
    cmp_data: {
        datasource: []
    }
};

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/components/Field_Components/AutoComplete/AutoComplete.js